module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "sub"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("STITCHING KNOW-HOW")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('h3', {
    staticClass: "subt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Making bunting")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("When making pennants and bunting (see ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01#page_20"
    }
  }, [_vm._v("pages 20")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/xhtml/#page_36"
    }
  }, [_vm._v("36")]), _vm._v(") there are some useful techniques to follow to ensure that you get good fabric shapes without too much thickness inside.")]), _vm._v(" "), _c('h4', {
    staticClass: "subt-2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Stitching and clipping points")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sew down one side of the pennant, stopping just before you reach the stitching line for the other side. (If you find it hard to judge the position of this stitching line, measure and mark it with a fabric marker before you start sewing.) Lift the presser foot and turn the fabric so that the foot is parallel to the top edge. Turn the hand wheel on the machine to make a single stitch, which should bring you to the second stitching line. Lift the presser foot again and turn the fabric to sew the second side of the pennant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Trim the point off the pennant just below the stitching. Cut away some fabric from the seam allowances either side of the point.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10.jpg"
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "subt-2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Clipping corners")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Trim the corner off the flag just beyond the stitching. Cut away some fabric from the seam allowances either side of the corner.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10-1.jpg"
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "subt-2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Clipping curves")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cut small wedges out of the seam allowances, cutting up close to the stitching. Space the wedges quite close together on tighter curves and further apart on softer ones.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10-2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Free machine embroidery")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This technique allows you to use the sewing machine like a drawing tool as you can move the fabric under the needle in any direction. In most cases, simply set the machine to a straight stitch, attach a darning foot and drop the feed dog (but do check your machine’s instructions).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Practice makes perfect working through basic shapes such as circles, squares and triangles is a great way to start and will soon build up your confidence. The charm of this style is that you’ll never create two identical pieces and each design will have its own quirky character.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Unless you are a very experienced machine embroiderer, it is best to place your work in an embroidery hoop when using fabrics with body.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10-3.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10-4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("See "), _c('a', {
    attrs: {
      "href": "#/xhtml/#page_40"
    }
  }, [_vm._v("page 40")]), _vm._v(" for this charming Felt Duck Brooch.")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "subt"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Useful stitches")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A number of projects in this section use some simple hand stitches, which are shown below.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10a-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', {
    staticClass: "subt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Silk ribbon embroidery")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A linen-cotton mix fabric is ideal for silk ribbon embroidery. You will need an emboidery hoop, chenille needles, silk ribbon and embroidery threads to provide texture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Other items used are a pair of small, sharp scissors, paper scissors for the templates, a fine, sharp pencil, ruler or tape measure and dressmaking pins.")]), _vm._v(" "), _c('h4', {
    staticClass: "subt-2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cutting and anchoring ribbon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Always cut ribbon at an angle of 45° to prevent fraying, and use a short length – 12in (30cm) is ideal. To begin, 2mm and 4mm ribbon is knotted at one end. For the wider 7mm and 13mm ribbon, a short end (tag end) is threaded into a size 18 or 13 needle and pulled sharply through to the back of the fabric, then secured with a few small stitches behind the petal about to be worked using a fabric-toned embroidery thread. The ribbon needs to sit smoothly on the right side of the fabric.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10a-2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10a-3.jpg"
    }
  })])])]), _c('h3', {
    staticClass: "subt"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Making pompoms")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("You can make pompoms using either the traditional method with cardboard, or with plastic pompom makers. This shows you the traditional method, which you can use for the Pompom Cupcakes on ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#page_22"
    }
  }, [_vm._v("page 22")]), _vm._v(" and the Pompom Santa on "), _c('a', {
    attrs: {
      "href": "#/xhtml/#page_32"
    }
  }, [_vm._v("page 32")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")]), _vm._v(" Cut out two identical cardboard discs to the diameter of the intended pompom. Mark out a smaller circle in the centre of each disc. This will form a hole to allow yarn to be passed through. As a rule of thumb, this circle should be half the diameter of the outer circle. Cut the inner circles out.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")]), _vm._v(" Hold the two cardboard discs together and start to wind your chosen yarn round the rings. Cover the ring entirely until the hole in the centre has almost disappeared.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11-3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")]), _vm._v(" With fabric scissors, cut through the yarn between the cardboard discs round the outer edge. Cut round the entire circumference, releasing all of the yarn and revealing the cardboard discs.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11-4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4")]), _vm._v(" Tie a spare piece of yarn between the discs to secure the middle of the pompom.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11-5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5")]), _vm._v(" Once knotted securely, tear the cardboard to release the pompom.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11-6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6")]), _vm._v(" Finish by trimming the pompom into a neat ball.")]), _vm._v(" "), _c('h3', {
    staticClass: "subt"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Faux Fur")])])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("The Fur Scatter Pillow on ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#page_42"
    }
  }, [_vm._v("page 42")]), _vm._v(" uses faux fur, and there are some important things to know before you start working with this lovely fabric.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h4', {
    staticClass: "subt-2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cutting faux fur")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Always use a scalpel to cut fur and never scissors. If you use scissors, you will end up cutting the long fibres off. Always cut on the reverse side of the fur.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As you cut with the knife, use your other hand to hold the fur above the knife. Use your fingers to gently pull the cut line apart (see right). Holding the work in this way is also important to counteract the drag or pull that a knife produces. Using a knife also reduces the amount of loose fur produced during the cutting process.")])]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11a-1.jpg"
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "subt-2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Hair direction and pile consideration")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As a general rule, fur should always face or point down towards the ground. If the hair has a much shorter pile, this rule can be reversed because it will give the illusion that the colour of the fur is deeper and more intense (rather like using velvet).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As fur is similar to hair and varies in length, this needs to be considered when plotting out a pattern or template. If you wish the fur to stop at a certain depth or level, you will need to deduct the hair length from the base of a pattern. This is where the hair will naturally overhang. If you do not do this, you will end up with a much deeper trim.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11a-2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h4', {
    staticClass: "subt-2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Attaching the lining/bias tape")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Attaching lining/bias tape not only allows you to finish the raw edges of fur, but it also helps give the fur ‘body’ and the feeling of fullness. The process stabilises the outer edges and means you do not need to use an iron (which should never be used on fur, whether it be real or faux). This technique is used throughout the projects found within this book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The tape should always be sewn directly onto the fur side to avoid puckering. When attaching the tape, comb any stray fur inwards under the tape while you sew. This prevents the fur becoming trapped within the seam, which will look ugly when the tape has been ‘rolled’ to the reverse of the fur (see right). The back of the blades of a pair of dressmaking snips are an ideal tool to comb back the fur.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11a-3.jpg"
    }
  })])]), _vm._v(" "), _c('h4', {
    staticClass: "subt-2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("‘Rolling’ the fur")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("‘Rolling’ the fur is a very important technique. After the lining/bias tape has been attached, roll the tape towards the reverse side of the fur. As your thumb folds the tape over, gently roll a little of the fur edge with the tape. Tack/baste the tape to the fur backing with a running stitch ½in (1cm) away from the seam. This will achieve a plumper edge and prevent the fur from looking flat.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11a-4.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "sub",
    attrs: {
      "id": "sub1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("FLOWERY BUNTING")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg12.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Make this colourful bunting in any fabric you wish. Choose contrasting and complementary designs for a burst of colour, whatever the weather outdoors.")])])])]), _c('div', {
    staticClass: "dot"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Materials:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("For each pennant: two pieces of floral cotton fabric measuring at least 6¾ x 8in (17 x 20cm)")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Sewing thread")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("¾in (2cm) floral bias binding the required length of the bunting, allowing for ties at each end")]), _vm._v(" "), _c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Tools:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Pencil")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Ruler")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Paper scissors")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Card for template")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Fabric marker")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Fabric scissors")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Pins")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Sewing machine")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Iron")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Knitting needle (optional)")])])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('h3', {
    staticClass: "subt"
  }, [_vm._v("Instructions:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")]), _vm._v(" On the card draw a triangle 6¾in (17cm) wide across the top and 8in (20cm) from top to tip. Cut this out to make a template. Use the template and fabric marker to draw as many pennants as you need on to the fabric. Cut out each one and pin them together in pairs, right sides together, matching all edges.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")]), _vm._v(" Set the sewing machine to a medium straight stitch. Taking a ⅜in (1cm) seam allowance, machine-sew down both sloping sides of each pennant, leaving the straight top edge open.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")]), _vm._v(" Trim the seam allowances and clip the point of each pennant (see ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#page_16"
    }
  }, [_vm._v("page 16")]), _vm._v("). Turn each pennant right side out and press flat. You will find the end of a knitting needle useful for turning out the point, but be careful not to push the needle right through the fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4")]), _vm._v(" Set the sewing machine to a medium zigzag stitch. Sew across the top of each pennant to stiffen the edge and prevent it from fraying.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5")]), _vm._v(" Slip the top edge of each pennant into the binding, spacing the pennants evenly. Pin each one in place. Turn under and pin the ends of the binding to neaten them.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6")]), _vm._v(" Set the sewing machine to a medium straight stitch. Starting at one end of the binding, machine along it close to the open edge, sewing over each pennant and taking out the pins as you go. Press the bunting.")]), _vm._v(" "), _c('h2', {
    staticClass: "sub"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("POMPOM CUPCAKES")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg13.jpg"
    }
  })])]), _c('div', {
    staticClass: "dot"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Materials:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("1 x 100g ball each of light brown and red yarn")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Scrap of yarn in a bright colour")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Small amounts of white and yellow felt")]), _vm._v(" "), _c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Tools:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Fabric scissors")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Paper and pinking shears")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Tailor’s chalk")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("1in (25mm) and 1¾in (45mm) pompom makers (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Pins")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Sewing needle")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Glue gun")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Card for templates")])])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('h3', {
    staticClass: "subt"
  }, [_vm._v("Instructions:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")]), _vm._v(" Photocopy the templates provided below and transfer them to a piece of card. Cut out and set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")]), _vm._v(" With red yarn, make up one 1in (25mm) pompom (using the pompom maker or the cardboard method if preferred). This will form a cherry for the top of the cupcake. Using light brown yarn and a 1¾in (45mm) pompom maker, make a larger pompom. Trim and shape each one into a neat ball and set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")]), _vm._v(" Lay the cupcake case template on to some yellow felt and mark out with chalk. With fabric scissors cut out the sides and base curve of the case. To create the serrated top of the case, carefully cut this top curve with pinking shears (shown by the zigzag red line on the template). Bring the short edges together, overlapping by about ⅛in (4mm), and pin to hold. Hand sew with a running stitch to secure in place, and remove the pin.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4")]), _vm._v(" Take a scrap of bright-coloured yarn and wrap it around the felt ring. Use the jagged tops as a guide. Leave two jagged points in between each line of yarn. Continue to wrap the yarn around the whole case until you reach the start. Tie both loose ends of yarn inside the case to secure. Trim the ends and rearrange evenly around the base of the case.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5")]), _vm._v(" Cut out the icing shape from white felt. Sew the cherry to the middle to secure. Assemble the cupcake by gluing the brown pompom into the case, followed by the icing topper complete with cherry.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg13-1.jpg"
    }
  })])]), _c('h2', {
    staticClass: "sub"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("FELT WINTER OWL")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg14.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("You could fill these owls with herbs or spices such as dried lavender or cinnamon to fill your home with a festive aroma.")])])])]), _c('div', {
    staticClass: "dot"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Materials:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("9½ x 4¼in (24 x 11cm) of brown or white felt for the body and wings")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("1¼ x 2¼in (3 x 6cm) of contrasting felt for the eyes")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("7¾ x ¾in (20 x 2cm) of red felt for the scarf")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Scrap of brown or black felt for the beak and pupils")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Two ¾in (2cm) diameter wooden buttons for the eyes (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("6–7¾in (15–20cm) of thin ribbon or string")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Embroidery cotton")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("About ½oz (8g) of toy filling")]), _vm._v(" "), _c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Tools:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Paper, fabric and embroidery scissors")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Embroidery needle")])])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('h3', {
    staticClass: "subt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Instructions:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")]), _vm._v(" Copy the templates below and cut them out. Transfer the shapes to the felt and cut two body pieces and two wings from the large piece of felt, and one beak and two eyes from the smaller pieces of felt.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")]), _vm._v(" Take the long piece of red felt and, with your embroidery scissors, cut little fringes along both ends. Do not cut them too thin or they will tear and fall off. About V4in (5–8mm) wide is ideal.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")]), _vm._v(" For button eyes, lay the felt circles on the front body piece with the wooden buttons on top. Secure them to the body with a few stitches through the buttonholes. For felt eyes, place the felt circles on the front body piece and stitch them in place with long straight stitches starting from the centre and radiating outwards. Cut a small circle of brown or black felt for each pupil, about ¼-½(0.5–1cm) diameter, and stitch in the centre of the eye. Finish with a French knot.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4")]), _vm._v(" Place the beak just below the eyes and sew it in place with a few overhand stitches.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5")]), _vm._v(" Take your length of ribbon and fold it in half. This will be the hanging loop. Place it at the top of the head on the wrong side of the back body piece. Make a couple of small stitches to secure it. Do not cut your thread. Put the front piece on top of the back piece, wrong sides together, with the ends of the hanging loop sandwiched between the two. Sew all the way round with blanket or overhand stitch. Stuff the owl with toy filling before closing it completely.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6")]), _vm._v(" Place the wings on the sides of the owl about halfway down and sew them along the top with a few overhand stitches.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("7")]), _vm._v(" Tie the scarf around the neck of the owl to keep it nice and warm.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg14-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg14-2.jpg"
    }
  })])]), _c('h2', {
    staticClass: "sub"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("SCOTTIE DOG BROOCH")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg15.jpg"
    }
  })])]), _c('div', {
    staticClass: "dot"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Materials:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Dog-coloured felt")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Embroidery thread")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Toy stuffing")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Ribbon")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Button")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Brooch finding")]), _vm._v(" "), _c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Tools:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Fabric scissors")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Embroidery needle")])])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg15-1.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "subt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Instructions:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")]), _vm._v(" Using the template (right), cut out two dog body shapes from the coloured felt.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")]), _vm._v(" Lay one piece on top of the other, aligning them perfectly, and secure them in the centre with a pin.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")]), _vm._v(" Starting at the top of the tail and moving anti¬clockwise, hand sew a blanket stitch around the outer edge. Pause when you reach the bottom of the dog’s back leg. Remove the pin.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4")]), _vm._v(" Fill the shape with a little toy stuffing and continue the blanket stitch until the dog is stitched closed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5")]), _vm._v(" Cut a length of ribbon 5in (12.5cm) long and cut one end at a sharp diagonal angle. Thread the button onto the ribbon.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6")]), _vm._v(" Place the ribbon around the dog’s neck and secure it at the back with a double knot. Cut off any excess ribbon, snipping the ends at an angle to prevent them from fraying.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("7")]), _vm._v(" Attach the brooch finding.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tip: filling your dog")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Use a knitting needle or pencil to insert the toy stuffing; use only very small amounts at a time and you will fill the shape more evenly.")])]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg15-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Try using different colours and button shapes to change the look and personalise the brooch. Or try adding a bell to create a lovely festive brooch for Christmas time!")])])])]), _c('h2', {
    staticClass: "sub"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("CROSS STITCH HEART")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg16.jpg"
    }
  })])]), _c('div', {
    staticClass: "dot"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Materials:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("14 count Aida fabric (evenweave and canvas can be used as alternatives)")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Anchor embroidery thread (see colours required, right); there are conversion charts readily available for different brands of thread such as DMC or Madeira, if preferred")]), _vm._v(" "), _c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Tools:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Size 24 or 26 tapestry needle")])])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('h3', {
    staticClass: "subt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Instructions:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")]), _vm._v(" Find the centre of your fabric by folding it in half lengthways and widthways, and mark the centre with a pin. The centre of the design can be found on the chart by following the arrows on each side, top and bottom. Mark the centre of the chart and begin stitching at the centre of the design.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")]), _vm._v(" When you have completed the cross stitch design, you can start on the outlines. All of the outlines are in long stitch with one strand of Black (403). The exception is the grid within the heart, which is stitched in one strand of Terracotta lt (338). Stitch this before any of the black outlines.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")]), _vm._v(" When you have finished stitching your design, wash it gently in warm water and washing-up liquid, trying not to crease the fabric. Rinse the piece thoroughly and roll the fabric in a towel to soak up the excess water. Place it face down on a towel and press with a hot iron, being careful not to distort the fabric.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Stitching notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Stitch count: 30 x 30.")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Design area: 2⅛ x 2⅛in (5.4 x 5.4cm) at 55sts per 4in (10cm).")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Where two colours are shown against a symbol, use one strand of each colour. One symbol on a square represents one full cross stitch worked in the colour specified. One full stitch on Aida is worked over one square, while on evenweave it is worked over two threads.")])]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg16-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', {
    staticClass: "subt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("How to work cross stitch")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("All cross stitch is worked in two strands unless indicated on the key. Each cross is made up of two stitches that together form an ‘X’. The bottom stitch is worked from lower left to upper right, and the top stitch is worked from upper left to lower right.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg16-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Cross stitch")])])])]), _c('h2', {
    staticClass: "sub"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("JELLY ROLL BAG")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg17.jpg"
    }
  })])]), _c('div', {
    staticClass: "dot"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Materials:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Nine 2½in (6.5cm) squares of light-coloured fabric")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Nine 2½in (6.5cm) squares of dark-coloured fabric")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("1 Jelly Roll strip for the gusset, 2½ x 22in (6.5 x 56cm)")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Lining fabric, 13 x 7¼in (33 x 18.5cm)")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Fabric for loop, 2½ x 3in (6.5 x 7.5cm) cut in half lengthways to make a strip 1%in (3.25cm) wide")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Fabric for handles, 2½ x 22in (6.5 x 56cm)")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Button for closure, 1in (2.5cm) diameter")]), _vm._v(" "), _c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Tools:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Basic sewing kit: sewing needles, pins, a ruler or tape measure, a small pair of scissors, fabric scissors, sewing thread")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Sewing machine")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Rotary cutting mat, ruler and cutter (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Pen to mark fabric")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Iron and ironing mat")]), _vm._v(" "), _c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Size:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("7 x 7in (18 x 18cm) excluding handles")])])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('h3', {
    staticClass: "subt"
  }, [_vm._v("Instructions:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")]), _vm._v(" On the back of the light squares, draw a diagonal line from corner to corner. Place these on top of the dark squares, right sides facing. Stitch along either side of the line, ¼in (0.5cm) away from the line.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")]), _vm._v(" Cut the squares in half along the drawn line and press the seams open. You will have 18 of these in total.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")]), _vm._v(" Lay nine of the squares out in three rows of three, with all the seams running in the same direction. Sew the squares together in rows, pressing the seams in alternating directions on each row. Sew the rows together to make a block. Press the seams open. Make two of these blocks, one for each side of the bag.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4")]), _vm._v(" Stitch the gusset around three sides of one of the blocks, right sides facing. Press the seams towards the gusset. Repeat, sewing the other block to the gusset. Press the seams towards the gusset.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5")]), _vm._v(" To make the loop for the button fastening, fold the fabric in half lengthways, wrong sides together, and fold the raw edges into the fold. Press and machine stitch along the edge.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6")]), _vm._v(" Fold the strip in half to form a loop and pin it centrally on the back of the bag on the wrong side, just below the top edge. The loop should be pointing downwards into the bag.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("7")]), _vm._v(" Now make two handles. Fold the piece of fabric for the handles in half lengthways, wrong sides together, and fold the edges into the middle as you did for the loop. Press and machine stitch along each edge to secure.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("8")]), _vm._v(" Cut the fabric in half widthways to make two handles. Pin these on the top edge of the bag, one on each side. Align the raw edges and position them in the middle of the two outside squares. The handles will be facing down into the bag.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("9")]), _vm._v(" To make the lining, fold the lining fabric right sides together so that it measures 6½ x 7¼in (16.5 x 18.5cm) and machine up each side. On one side leave a 2in (5cm) gap in the middle for turning through later.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("10")]), _vm._v(" To shape the lining base, refold the lining so that the seams are in the middle and mark 1in (2.5cm) on either side of one of the seams across the point. Stitch across between these two marks. Secure the stitching and cut off the point leaving Viin (0.5cm) seam allowance. Repeat for the second seam.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("11")]), _vm._v(" Place the outer bag inside the lining, right sides together. Match the side seams and pin. Sew around the top of the bag.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("12")]), _vm._v(" Turn the bag right-side out, sew the opening in the lining closed and press.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("13")]), _vm._v(" Sew the button on the bag about %in (1cm) down from the top edge.")])]), _c('h2', {
    staticClass: "sub"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("POMPOM SANTA")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg18.jpg"
    }
  })])]), _c('div', {
    staticClass: "dot"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Materials:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("1 x 100g ball each of red and white yarn")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Small amounts of red and beige bulky (chunky) yarn")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Five 11¾in (30cm) chenille sticks")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("One wooden ball, 2in (5cm) in diameter")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("7¾in (20cm) length of gold craft wire")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Small toilet roll inner")]), _vm._v(" "), _c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Tools:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Paper scissors")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Glue gun")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("3⅜in (85mm) and 1in (25mm) pompom makers (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Long, large-eyed sewing needle")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Black marker pen")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Pink blending pencil")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Wire cutters")])])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('h3', {
    staticClass: "subt"
  }, [_vm._v("Instructions:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")]), _vm._v(" Start by making a frame for the hat. Lay three chenille sticks across each other to form a star shape. Twist the sticks together and mould into a cone shape. Cut a ⅜in (1cm) section from the toilet roll inner (keep it as a ring) and attach the chenille stick ends, spacing them evenly round the circumference of the cardboard, by folding them under and round the card. Once secure, bend the cone shape over to make the base for the hat. Cover the entire shape with the chunky red yarn, concealing the card and sticks. Secure the yarn by gluing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")]), _vm._v(" To make the rim of the hat, cover two chenille sticks in white yarn. Fold about 3in (7.5cm) of each end of the sticks into the centre so that they meet in the middle and flatten the sticks using your fingers. Then hold both sticks together lengthways and wind more white yarn around to encase them. Continue until you reach a desired thickness. Bend this piece round the base of the red hat and secure by stitching at the rear with spare white yarn.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")]), _vm._v(" Using the 3⅜in (85mm) pompom maker, make one pompom in red yarn. Using the 1in (25mm) maker, complete a second pompom in white yarn. Trim into neat balls using fabric scissors. Glue the wooden ball on to the top of the red pompom. Draw on the eyes and add some rosy cheeks using the pen and pencil. Glue the white pompom to the end of the hat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4")]), _vm._v(" The same method is used to construct both the beard and hair. Cut ten lengths of beige chunky yarn approximately 7¾in (20cm) long. Tie the yarn in the centre to combine and secure. Make a second bunch of yarn in the same way. Glue one bunch onto Santa’s face to create a beard. The knot should face towards the wood to conceal it. Spread the yarn across the face, sticking it into position with some glue. Trim the beard into shape, using the photograph for guidance. Glue the second bunch to Santa’s head, using the same method, to create the hair. Glue the hat onto the head and trim Santa’s hair as desired. Sew a loop of red yarn on to the hat to allow it to hang.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5")]), _vm._v(" The final touch is to construct a pair of spectacles. Take the craft wire and wrap it round a pen twice, about 2in (5cm) away from one of the ends. This will create one of the lenses. Leave a small gap and repeat the process to form the spectacles. Cut the wire 1in (2.5cm) away from each lens and bend inwards. Place the spectacles on to Santa’s head and glue into position.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg18-1.jpg"
    }
  })])]), _c('h2', {
    staticClass: "sub"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("DAISY BROOCH")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg19.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("This festive red alternative flower requires only the very simplest of embroidery stitches to create a charmingly naïve effect. You can stitch any pattern of running stitches you like on to the felt, though it works best if the stitching relates to the shape of the flower.")])])])]), _c('div', {
    staticClass: "dot"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Materials:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Two pieces of purple felt measuring at least 4in (10cm) square")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Stranded pink and blue embroidery thread")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Craft glue")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Brooch finding")]), _vm._v(" "), _c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Tools:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Paper scissors")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Fabric scissors")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Embroidery needle")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Small, stiff-bristle paintbrush")])])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('h3', {
    staticClass: "subt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Instructions:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")]), _vm._v(" Copy the daisy motif and cut it out to make a template. Lay the template on a piece of purple felt and draw and cut out one flower.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")]), _vm._v(" Split lengths of embroidery thread into groups of three strands. Using one group at a time, embroider the cut-out flower as shown with a simple design in running stitch. Repeat in a second colour.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")]), _vm._v(" Sew the finding to the centre of the remaining piece of felt. Lay this piece on the back of the cut-out flower with the finding in the required position and make sure that all of the cut-out flower is covered by the finding piece of felt.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4")]), _vm._v(" Using the paintbrush, paint craft glue all over the back of the cut-out flower brushing it right up to the edges of the petals. You will need to work quite quickly before the glue dries. Press the glued flower on to the other piece of felt, ensuring the finding is in the right place. Leave to dry.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5")]), _vm._v(" Cut out the backing felt, carefully cutting around the flower.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg19-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg19-2.jpg"
    }
  })])]), _c('h2', {
    staticClass: "sub"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHRISTMAS BUNTING")])])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg20.jpg"
    }
  })])]), _c('div', {
    staticClass: "dot"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Materials:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Red and green floral fabric, 4 x 4¾in (10 x 12cm) per flag, and the same to use as a lining")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Red bias binding ¾in (2cm) wide, measure to the desired length of bunting, plus ties at the ends")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Large red jacket buttons")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Green embroidery thread")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Sewing thread to match the bias binding")]), _vm._v(" "), _c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Tools:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Pencil")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Ruler")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Card for template")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Fabric marker")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Pins")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Paper and fabric scissors")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Iron")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Sewing machine")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Large upholstery needle or knitting needle")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Hand sewing needle")])])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('h3', {
    staticClass: "subt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Instructions:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")]), _vm._v(" Start by transferring the triangle template (right) on to card and cut it out.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")]), _vm._v(" With the fabric pinned right sides together, place the template on top and carefully draw around all of the edges using a fabric marker. Remove the template and secure the two layers together with pins, then cut round the marked lines. Repeat this process until you have enough flags for your bunting length.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")]), _vm._v(" Set a sewing machine to a medium-sized stitch. Take a flag and start to sew down one of the sides. Seam allowance has been added to the template at ⅜in (1cm). As you reach the end of the first side, stop the stitching ⅜in (1cm) away from the base of the work. Lift the foot and turn the flag towards you and continue stitching down the opposite edge. Now clip the excess fabric from the tip of the flag and turn right side out. Use the eye of a large upholstery or knitting needle to ease the tip of the flag out. Take care not to push too hard as this may result in the needle coming through the work. Press the flag flat and trim away the protruding seam allowance to maintain a straight edge along the top. Repeat this process until all of the flags have been completed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4")]), _vm._v(" Using an iron, carefully press the bias binding in half lengthwise, matching the edges together. Sandwich each flag between the folded bias and pin into position. Space evenly and alternate red flags with green flags; I have spaced mine 1in (2.5cm) apart. Make sure you leave enough free bias at the start and finish to allow for ties. Sew the bias binding together along the entire length using a sewing machine set to a medium straight stitch. Stitch as close to the edge as you can. Press the bunting flat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5")]), _vm._v(" Between each flag, hand sew a red jacket button in the centre of the bias binding using green embroidery thread.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg20-1.jpg"
    }
  })])]), _c('h2', {
    staticClass: "sub"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FELTIE MOUSE")])])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg21.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Pink and white are traditional colours for sugar mice, but you could also make a grey mouse that is closer to the real thing!")])])])]), _c('div', {
    staticClass: "dot"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Materials:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Fleece")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Merino in black and pink")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Pale pink felt fabric")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("2 black seed beads")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Black and pink thread")]), _vm._v(" "), _c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Tools:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Felting needle")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Foam block")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Scissors")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Sewing needle")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Beading needle")])])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg21-1.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "subt"
  }, [_vm._v("Instructions:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")]), _vm._v(" First you need to form a low, flat-bottomed egg shape with fleece, tapering it at the end for the nose. Take a small handful of fleece. Pull out the wool fibres into a long strand, then curl it tightly into a bundle. Place the item on a working surface such as a needle felting base, an old cushion or foam block. Needle the wool repeatedly with your felting needle, inserting the needle in and out with a straight up and down movement. Move the piece around to work at it from all sides. Add more wool in stages, layering and needling in thin strands to achieve the desired size and shape. It should start to form a coarse-looking, fairly firmly packed shape. Check your sizing and also if the shape is firm enough. Keep comparing with the photograph (below) and amend as you go.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")]), _vm._v(" Cover the shape with pink merino wool.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")]), _vm._v(" Cut teardrop-shaped ears and a 3½in (9cm) long strip for a tail from the pink felt fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4")]), _vm._v(" Take the felt ears and check where they will be positioned at the front of the mouse. Take the felting needle and secure each ear in place by needling repeatedly at the point of the teardrop shape. This will make a small indent and will also slightly cup the ear. Take the tail and sew it firmly into place at the back of the mouse body using the sewing needle and pink thread.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5")]), _vm._v(" For the whiskers, thread the sewing needle with black thread. Do not knot the end. Sew into one side of the nose leaving a ¾in (2cm) strand at the entry site. Pull through to the opposite side through the nose, double back through to the original entry site and then back out of the second hole. Cut the thread, leaving a ¾in (2cm) strand. Repeat three times.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6")]), _vm._v(" Needle felt some black wool for the nose.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("7")]), _vm._v(" Use a beading needle to sew on black seed beads for the eyes.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg21-2.jpg"
    }
  })])]), _c('h2', {
    staticClass: "sub"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("FELT DUCK BROOCH")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg22.jpg"
    }
  })])]), _c('div', {
    staticClass: "dot"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Materials:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Tracing paper")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("White or cream felt, 3¼ x 3¼in (8 x 8cm)")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Scraps of orange felt")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Calico, 7 x 7in (18 x 18cm)")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Wadding/batting, 3¼ x 3¼in (8 x 8cm)")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Backing felt, 7 x 7in (18 x 18cm)")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Black thread")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Brooch back")]), _vm._v(" "), _c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Tools:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Embroidery hoop 6¼in (16cm) in diameter")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Sewing machine")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Paper scissors")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Fabric scissors")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Embroidery scissors")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Pins")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Needle")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Tacking/basting thread")])])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('h3', {
    staticClass: "subt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Instructions:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")]), _vm._v(" Trace the duck template and cut it out from the white or cream felt, leaving a ½in (1cm) border.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")]), _vm._v(" Stretch the calico on the hoop. Lay the wadding/batting centrally on top of the calico.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")]), _vm._v(" Lay the felt duck shape on top of the wadding/batting and the paper pattern on top of the felt. Pin through all layers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4")]), _vm._v(" Cut the orange scraps slightly bigger than the beak and feet shapes. Lay these pieces in place under the pattern, tacking/basting in place.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5")]), _vm._v(" Sew the outline. Starting by the top of the beak, follow the outline around the head, sew down the curving line into the body and retrace to join the outline. Continue around the tail feathers and down to the right leg. Travel up to the top of the right leg, back down the leg and around to the lower point of the foot. Stitch up into the foot and back down. Continue around the foot up into the leg and back down to re-join the outline. Continue the outline sewing the left leg in a similar way, around the front and up to the neck. Continue around the beak, travelling across and back when you reach the top where it joins the body, finishing at the starting point.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6")]), _vm._v(" Carefully tear away the tracing paper pattern.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("7")]), _vm._v(" To make the eye, sew several stitches in a circular movement.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("8")]), _vm._v(" Carefully cut around the duck outline, leaving a small margin.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("9")]), _vm._v(" Trim away the excess wadding/ batting and calico so that they sit just under the felt.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("10")]), _vm._v(" Place the work on the backing felt stretched in a hoop. Pin and stitch the outline. Start at the top of the beak and follow all the way around and back to the starting point.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("11")]), _vm._v(" Trim away any excess felt.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("12")]), _vm._v(" Sew a brooch back onto the centre of the backing felt.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg22-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Duck template: actual size")])])]), _c('h2', {
    staticClass: "sub"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("FUR SCATTER PILLOW")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg23.jpg"
    }
  })])]), _c('div', {
    staticClass: "dot"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Materials:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Faux chocolate chinchilla fur")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("39½in (1m) of backing fabric")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Four checked tweeds, each 4¼ x 4¼in (11 x 11cm)")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Toy stuffing or a made-to-measure pillow pad")]), _vm._v(" "), _c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Tools:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Fabric scissors")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Scalpel")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Sewing thread")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Sewing machine")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Chalk")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Long, strong pins")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Ruler, tape measure and set square")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Iron")]), _vm._v(" "), _c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Size:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Finished pillow measures 15 x 15in (38 x 38cm)")])])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('h3', {
    staticClass: "subt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Instructions:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")]), _vm._v(" Sew the four squares of tweed together using a ½an (1cm) seam allowance. Press the seams flat at the rear with a hot iron and place to one side. Lay out the backing fabric and cut out two squares measuring 15¾ x 15¾in (40 x 40cm). Fold over 6in (15cm) along one side of the first square and press. Repeat this process for the other square and put to one side.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")]), _vm._v(" Read the instructions on working with faux fur (see ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#page_19"
    }
  }, [_vm._v("page 19")]), _vm._v(") before you start cutting out. Chalk out strips directly onto the fabric side of the fur with a depth of 3½in (9cm) and 15in (38cm) in length horizontally. With a set square, mitre the corners. The shorter line should measure 7¾in (20cm) in length and the longer 15in (38cm). Now add a ½in (1cm) seam allowance round all edges. You need four strips in total. The fur direction should run away from the shorter horizontal line. Cut out using a scalpel.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")]), _vm._v(" Line up the short edges of the fur strips along the four edges of the tweed. Pin and machine sew into position with a large stitch, combing any stray fur inwards as you sew. Complete all four edges. Pin the mitred corners and stitch them closed in the same manner.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4")]), _vm._v(" Place the fur-trimmed tweed facing up and layer over the backing pieces. The first piece should be laid with the pressed edge facing you and resting over the middle of the pillow. Match up the outer corners and pin. Add the second backing section likewise. Machine stitch the entire pillow round the perimeter using a ½in (1cm) seam allowance, combing the fur as you stitch. Pull the work through and fill the pillow with toy stuffing or a pillow pad.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg23-1.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "sub"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("NEEDLEPOINT HEN")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg24.jpg"
    }
  })])]), _c('div', {
    staticClass: "box"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('h3', {
    staticClass: "subt"
  }, [_vm._v("How to work half-cross tent stitch")]), _vm._v(" "), _c('p', {
    staticClass: "nondent"
  }, [_vm._v("As the name implies, this method involves creating a slanted stitch (half a cross stitch) worked diagonally. It does not matter in which direction the stitches slant as long as they all slant in the same direction. Work in rows alternately from left to right and then right to left, counting the squares and following the colour key. Each square on the graph is one slanted stitch (see above).")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg24-4.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('div', {
    staticClass: "dot"
  }, [_c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Materials:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("10 hole per inch (2.5cm) white interlock canvas")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Anchor tapestry wool (see colour key below)")]), _vm._v(" "), _c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Tools:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Size 18 tapestry needle")])]), _vm._v(" "), _c('h3', {
    staticClass: "subt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Instructions:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")]), _vm._v(" Start your stitching from the centre outwards to ensure that you fit the whole design on your measured piece of canvas. Locate the centre stitch of your graph by following the arrows on each side, top and bottom. Mark this centre stitch and start your piece from here.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")]), _vm._v(" When starting a new colour, leave a 1in (2.5cm) length of thread at the back of your work and then, while working your first row of stitches, catch this thread into the back of them to secure it in place. When ending a colour, run a 1in (2.5cm) length of wool through the stitches at the back of your work to secure and snip off.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg24-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg24-2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg24-3.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Stitching Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Stitch count: 45 x 45.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Design area: 4½ x 4½in (11.4 x 11.4 cm) at 10 sts per 1in (2.5 cm).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Each single square on the chart (opposite) represents one half-cross tent stitch. The symbol in that square represents the colour to be used, which is specified in the colour key below.")])])]), _c('h2', {
    staticClass: "sub"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("SILK RIBBON POINSETTIA")])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg25.jpg"
    }
  })])]), _c('div', {
    staticClass: "dot"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Materials:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Small amount of black fabric (or colour of your choice)")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("60in (1.5m) of 13mm ribbon in red")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Embroidery thread in yellow, gold and base fabric colour (black)")]), _vm._v(" "), _c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Needles:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Two size 13 needles, One size 18 needle, One size 24 needle and One size 8 embroidery needle")])])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('h3', {
    staticClass: "subt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Instructions:")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")]), _vm._v(" Read the basic guidance for working with silk ribbon on ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#page_17"
    }
  }, [_vm._v("page 17")]), _vm._v(" before you start. Then, transfer the design to your fabric base. If you are using black fabric, use a white pencil to transfer the design. Pin the template on to the fabric and mark the position of the petals. If you are using black fabric, it is helpful if a red thread is used to work a ring of small stitches to mark the centre circle on the fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")]), _vm._v(" Cut a 12in (30cm) length of red ribbon at an angle, thread a short end into a size 13 needle and take it through to the back of the fabric at X of petal 1. Secure the ribbon end with a few small stitches behind the petal about to be worked. Now lay the ribbon in position and take the needle down through the centre of the ribbon at Y, place the eye end of a second large needle in the loop and continue pulling the ribbon round the needle. Stop pulling when all the ribbon is pulled through, remove the needle and very gently pull the ribbon to form a tip to the petal, then stop pulling the ribbon again. Now secure the ribbon with a few small stitches behind the petal just worked and cut the ribbon at an angle.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")]), _vm._v(" Continue to work alternate petals 2, 3, 4, 5, 6 and 7, fastening off after each one. Now work petal A as before, but a little shorter and very slightly raised, remembering to finish off after each petal is worked. Work the remaining petals, B to G, in order.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4")]), _vm._v(" To make the flower centre, thread six strands of yellow embroidery thread into a size 18 needle and knot one end. Work 2-loop French knots to fill the centre. Using gold thread, add a few 2-loop French knots at random to complete, then fasten off.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg25-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg25-2.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "sub"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("CHRISTMAS TEA LIGHT")])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg26.jpg"
    }
  })])]), _c('div', {
    staticClass: "dot"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Materials:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Small amount of white yarn")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Three sheets of burgundy felt, 8¼ x 11¾in (210 x 297mm)")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Felt scraps in two shades of green")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("6 large gold sleigh bells")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("2¼yd (2m) of red satin ribbon ⅛in (3mm) wide")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("One small glass with a 9in (23cm) circumference at the base")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Battery-operated tea light (optional)")]), _vm._v(" "), _c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Tools:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("One sheet of paper, 8¼ x 11¾in (210 x 297mm)")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Fabric and paper scissors")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Tailor’s chalk")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("1in (25mm) pompom maker")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Hand sewing needles")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Glue gun")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Ruler")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Pair of compasses")])])]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg26-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Mistletoe template: actual size")])])]), _vm._v(" "), _c('h3', {
    staticClass: "subt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Instructions:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")]), _vm._v(" Photocopy the mistletoe template (right) and set aside. Now make your own template for the base of the tea light holder. Set the compasses to 2¾in (7cm) wide and draw a circle on to paper. Use the circle to mark out three base sections on to burgundy felt. Neatly cut out all three and layer together, securing with a glue gun. On a separate sheet of felt, mark out a rectangle measuring 4¾ x 9in (12 x 23cm). Cut out and fold together lengthways, gluing to secure, and allow to dry.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")]), _vm._v(" With some chalk, mark a central line down the folded felt along the longest edge. Using fabric scissors, cut straight lines at ½in (1cm) intervals from the raw edge in towards the chalked line. Bring the short edges together and secure by sewing, but only down to the chalk line. This should form a cuff to grip the base of the glass. The raw edges should fan away from the glass. Place the cuffed glass centrally onto the base section and glue the fanned rays to secure into place. Remove the glass so that you can decorate the holder.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")]), _vm._v(" Make up six 1in (25mm) pompoms in white yarn, trimmed into neat balls. Mark out as many mistletoe leaves in green felt as you require (I have used six per shade of green) and cut them out. Cut the ribbon into 11¾in (30cm) lengths and bunch together, securing at the base with a stitch.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4")]), _vm._v(" Now all of your components are ready -pompoms, mistletoe leaves, sleigh bells and ribbon bunches – simply arrange and sew them on to the base. Try a few options first by pinning them down before you decide on a final composition. Please note that if you have a slightly wider bottomed glass, all you have to do is increase the length of the cuff and possibly enlarge the base section a little. Never use a real tea light without the glass.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg26-2.jpg"
    }
  })])]), _c('h2', {
    staticClass: "sub"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("FELT PLACE SETTING")])]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg27.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("This set looks stylish with a very simple embroidered design. If you are feeling more confident with your embroidery, try stitching a more intricate design or create a unique family monogram.")])])])]), _c('div', {
    staticClass: "dot"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Materials:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("9¾ x 6in (25 x 15cm) of grey felt")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("4 x 4in (10 x 10cm) of white felt")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("23½in (60cm) of red ric-rac")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Red embroidery cotton")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Fabric glue")]), _vm._v(" "), _c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Tools:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Paper, fabric and embroidery scissors")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Zigzag scissors")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Dressmaking pins")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Embroidery needle")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Pencil, ruler and pair of compasses")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Paper")])])]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_c('h3', {
    staticClass: "subt"
  }, [_vm._v("Instructions:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")]), _vm._v(" On your piece of paper draw a 4 x 6in (10 x 15cm) rectangle, a 6 x 2in (15 x 5cm) rectangle and two circles of 2¼in (6cm) and 1¼in (3cm) in diameter. Cut out these templates and transfer them to the felt. Cut two large rectangles and one small rectangle from the grey felt using fabric scissors, and one circle of each size from the white felt using the zigzag scissors.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")]), _vm._v(" For the cutlery pouch, place the large circle on one of the large rectangles, roughly in the middle. Starting from the centre of the circle and going through both layers, make a cross (+) using long straight stitches and then an x shape. This will make a lovely star. Add a French knot at the end of each stitch, leaving a small gap.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")]), _vm._v(" Place a thin line of fabric glue about ¾in (1.5cm) from the top edge, and another one ¾in (1.5cm) from the bottom edge of the felt rectangle. Stick on the ric-rac by pressing it down firmly for a few seconds. Leave about ½in (1cm) of ric-rac sticking out at the sides.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4")]), _vm._v(" Place this grey rectangle on top of the other one, wrong sides together, and sew them together on three sides with a blanket stitch. Leave the top open. Tuck the ends of the ric-rac inside as you stitch for a clean finish.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5")]), _vm._v(" For the napkin ring, place the small circle in the middle of the small rectangle of felt and repeat step 2 for the stitching.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6")]), _vm._v(" Repeat step 3 to attach the ric¬rac close to the long edges.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("7")]), _vm._v(" Close the napkin ring at the back by overlapping it slightly and sewing together with a few cross stitches.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg27-1.jpg"
    }
  })])]), _c('h2', {
    staticClass: "sub"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("HEART BROOCH")])]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg28.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Create a vintage look using a piece of old lace, soft colours and lovely French knots as the decorative outer stitch (see brown brooch). These pretty little badges also make wonderful wedding favours at a vintage-themed wedding celebration.")])])])]), _c('div', {
    staticClass: "dot"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Materials:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Neutral-coloured lightweight fabric, cotton or calico, 5½ x 5½in (14 x 14cm)")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Coloured lightweight fabric, cotton or calico")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Pink felt")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Embroidery threads")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Badge blank (if using a badge machine) or a 1¼in (30mm) metal cover button")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Brooch finding")]), _vm._v(" "), _c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Tools:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Embroidery hoop, 4in (10cm) in diameter")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Fabric scissors")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Embroidery needle")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Badge machine (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Pliers (if using a metal cover button)")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Craft glue gun")])])]), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg28-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Heart motif template: actual size")])])]), _vm._v(" "), _c('h3', {
    staticClass: "subt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Instructions:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")]), _vm._v(" Secure the neutral-coloured lightweight fabric in the embroidery hoop.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")]), _vm._v(" Cut a circle of coloured lightweight fabric: use either the manufacturer’s guide for size if using a badge machine, or the instructions provided if using a metal cover button. Place the circle of fabric onto the centre of the embroidery hoop.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")]), _vm._v(" Using the template above, cut out a heart shape from a piece of felt and place in the centre of the circle of fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4")]), _vm._v(" Using a contrasting thread colour, hand sew back stitch around the inside edge of the heart, pushing the needle through all three layers of fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5")]), _vm._v(" Using running stitch, carefully sew a dashed circle around the heart shape – the circle should have a diameter of about 1¼in (3cm), as it will sit right on the edge of the badge.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6")]), _vm._v(" With your stitching complete, take the fabric out of the embroidery hoop and cut around the coloured circle of fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("7")]), _vm._v(" If you are using a badge machine, follow the manufacturer’s instructions to construct the badge. If you are using a metal cover button, remove the button shank with a pair of pliers and discard. Carefully fold the fabric around the button, following the instructions. Once in place, secure the cover button back and glue a brooch back to the rear using a glue gun.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg28-2.jpg"
    }
  })])]), _c('h2', {
    staticClass: "sub"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("JELLY ROLL PILLOW")])]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg29.jpg"
    }
  })])]), _c('div', {
    staticClass: "dot"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Materials:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Pillow fabric, linen or linen-cotton blend, 12½ x 36½in (32 x 93cm)")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Jelly Roll scraps to cover buttons, 6 pieces 2½ x 1½in (6.5 x 4cm)")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("6 plastic self-cover buttons, 1¼in (3cm) in diameter")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Sewing thread to match pillow fabric")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("13¾in (35cm) square pillow pad")]), _vm._v(" "), _c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Tools:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Basic sewing kit: sewing needles, pins, a ruler or tape measure, a small pair of scissors, fabric scissors, sewing thread")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Sewing machine")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Rotary cutting mat, ruler and cutter (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Pen to mark fabric Iron and ironing mat")]), _vm._v(" "), _c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Size:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("12 x 12in (30.5 x 30.5cm)")])])]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('h3', {
    staticClass: "subt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Instructions:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")]), _vm._v(" On the wrong side of the fabric, turn a 4in (10cm) double hem (turn over 2in/5cm and then 2in/5cm again) on one of the short ends. Machine stitch to secure.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")]), _vm._v(" On the other short end, turn a 5in (13cm) double hem to the wrong side (turn over 2½in/6.5cm, then 2½in/6.5cm again). Machine stitch to secure, then stitch along the folded edge, ⅛in (0.25cm) in.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")]), _vm._v(" On the deepest hem end of the fabric on the right side, mark and stitch six buttonholes. These should be approximately 1½in (4cm) apart. To space them evenly, measure from the middle out towards the raw edges.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4")]), _vm._v(" Lay the fabric wrong-side up and fold in the edge with the buttonholes by 5in (13cm). Fold in the other end by 10in (25.5cm). The buttonholed end should overlap the longer end. Pin in place and then stitch along the raw edge to secure. You can zigzag to neaten if you like.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5")]), _vm._v(" Turn the pillow cover right side out and press.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6")]), _vm._v(" Make the buttons by covering them in the Jelly Roll scraps following the button manufacturer’s instructions.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("7")]), _vm._v(" Mark the button positions through the buttonholes, and stitch the buttons in place.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("8")]), _vm._v(" Insert the pillow pad and do the buttons up.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg29-1.jpg"
    }
  })])]), _c('h2', {
    staticClass: "sub"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("POMPOM CARD PEGS")])]), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg30.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("These pretty pegs are quick and easy to make – if the postman brings more cards than you anticipated, just make a few more!")])])])]), _c('div', {
    staticClass: "dot"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Materials:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Small amounts of of red and white yarn")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Red double-sided satin ribbon, ½in (1.5cm) wide, the desired length")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Scraps of light and dark green felt")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Six wooden spring-loaded laundry pegs")]), _vm._v(" "), _c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Tools:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Paper scissors")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("1in (25mm) pompom maker")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Glue gun")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Pencil and tailor’s chalk")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Craft paper or card")])])]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_c('h3', {
    staticClass: "subt"
  }, [_vm._v("Instructions:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")]), _vm._v(" Start by deciding how long you wish the ribbon that will suspend and display your Christmas cards to be. Tie a knotted loop at either end to allow it to hang and place it to one side.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")]), _vm._v(" Decide on a number of pegs to make. For each peg, use either red or white yarn to determine the berry type.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")]), _vm._v(" Either trace or photocopy the holly leaf template below onto some craft paper or card, then cut it out using paper scissors. Use this template and tailor’s chalk to mark out as many leaves on the scraps of felt as you require. As a ratio, I have used three leaves per peg and 2:1 per colour. Cut out all the leaves and place to one side.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4")]), _vm._v(" To complete a berry, make a pompom using either red or white yarn and a 1in (25mm) pompom maker. Make two berries per peg. Trim the pompoms into neat balls and set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5")]), _vm._v(" Assemble each peg by layering three leaves, alternating the colours. Attach the leaves to the peg using the glue gun. At the same time, glue two berries together and then on to the holly leaves. See")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("the photographs for guidance on positioning leaves and berries.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6")]), _vm._v(" Complete this process until you have enough pegs, then hang your cards to dazzle your guests!")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg30-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Holly leaf template: actual size")])])]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg30-2.jpg"
    }
  })])]), _c('h2', {
    staticClass: "sub"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("FABRIC BUTTON FLOWER")])]), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg31.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Gingham fabric is great if you are not a confident embroiderer, as the square pattern gives you a grid to work the stitches on. If embroidery isn’t your thing, make a simpler version of this flower, like the turquoise one here, using a motif from a printed fabric to decorate the button. This bright, fresh-looking flower makes a great decoration for any bag.")])])])]), _c('div', {
    staticClass: "dot"
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Materials:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Piece of medium-weight pink cotton gingham fabric with small checks, 6in (15cm) square")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("1½in (38mm) self-cover button")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Embroidery threads")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Craft glue")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Lightweight pink cotton gingham fabric with large checks, 22 x 4in (55 x 10cm)")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Length of green ric-rac to fit button circumference")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Sewing threads to match fabrics and ric-rac")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Brooch finding")]), _vm._v(" "), _c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Tools:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Pair of compasses")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Embroidery hoop 4in (10cm) in diameter")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Embroidery needle")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Fabric scissors")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Hand-sewing needle")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Sewing machine")])])]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_c('h3', {
    staticClass: "subt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Instructions:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")]), _vm._v(" Using the compasses, draw a central 2¾in (7cm) diameter circle on the medium-weight gingham fabric. Put the fabric into the hoop. Use simple embroidery stitches to sew a design into the centre of the circle. Here, I have used three strands of thread in two shades of green to work a lazy daisy surrounded by French knots and cross stitches.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")]), _vm._v(" Following the manufacturer’s instructions, cover the button with the embroidered fabric, making sure you position the stitched design centrally.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")]), _vm._v(" Using tiny running stitches in thread to match the ric-rac, sew the ric-rac around the edge of the button. Tuck the ends to the back and hold them in place with craft glue.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4")]), _vm._v(" Machine sew the two short ends of the long strip of fabric together to make a tube. Press the seam flat. Wrong sides facing, fold the tube in half. Run a line of running stitch along the free edges of the tube, stitching through both layers of fabric. Pull up the stitches as tightly as possible to gather the fabric and secure the thread with a few back stitches.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5")]), _vm._v(" Position the button centrally on the ruffle and arrange the gathers so that they fan out evenly around the button. Thread a hand-sewing needle with thread to match the button fabric, then double and knot the thread. Starting from the back of the ruffle, bring the needle through in line with the edge of the button. Take a small stitch through the fabric at the edge of the button, under the ric-rac, and then go back down through the ruffle. Work around the button in this way, sewing it firmly to the ruffle.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6")]), _vm._v(" Add a brooch finding to the back of the flower.")])]), _c('h2', {
    staticClass: "sub"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("NEEDLEPOINT SNOWMAN")])]), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg32.jpg"
    }
  })])]), _c('div', {
    staticClass: "dot"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Materials:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("10 hole per inch (2.5cm) white interlock canvas")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Anchor tapestry wool (see colour key below)")]), _vm._v(" "), _c('h4', {
    staticClass: "subt-1"
  }, [_vm._v("Tools:")]), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("Size 18 tapestry needle")])])]), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_c('h3', {
    staticClass: "subt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Instructions:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")]), _vm._v(" Start your stitching from the centre outwards to ensure that you fit the whole design on your measured piece of canvas. Locate the centre stitch of your graph by following the arrows on each side, top and bottom. Mark this centre stitch and start your piece from here.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")]), _vm._v(" When starting a new colour, leave a 1in (2.5cm) length of thread at the back of your work and then, while working your first row of stitches, catch this thread into the back of them to secure it in place. When ending a colour, run a 1in (2.5cm) length of wool through the stitches at the back of your work to secure and snip off.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg32-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg32-2.jpg"
    }
  })])]), _c('div', {
    staticClass: "box"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_c('h3', {
    staticClass: "subt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Stitching Notes:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Stitch count: 44 x 52.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Design area: 47/16 x 5¼ in (11.2 x 13.2 cm) at 10 sts per 1in (2.5cm).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Each single square on the chart (opposite) represents one half-cross tent stitch. The symbol in that square represents the colour to be used, which is specified in the colour key above.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("See ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#page_44"
    }
  }, [_vm._v("page 44")]), _vm._v(" for instructions on working half-cross tent stitch.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-057d52d5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Chapter01.vue
// module id = 84
// module chunks = 0